import { render, staticRenderFns } from "./WsAppHeader.vue?vue&type=template&id=6285f23c&"
import script from "./WsAppHeader.vue?vue&type=script&lang=js&"
export * from "./WsAppHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports